<main id="content" role="main" class="main bg-white">
  <!-- Content -->
  <div class="container py-10 py-sm-7">
    <div class="mx-auto"  *ngIf="platform=='web'">
      <!-- Card -->
      <div class="mb-5 p-2 ">
        <a class="d-flex justify-content-center mb-2 mt-5" routerLink="/">
          <img class="zi-2" src="../../../assets/images/DumyUser/touch.png" alt="Image Description" style="width: 8rem;">
        </a>
        <!-- Form -->
        <div class="js-validate needs-validation" novalidate>
          <div class="text-center">
            <div class="mb-5">
              <h1 class="display-5">
                {{ 'SIGN_IN' | translate }}
              </h1>
              <p>{{'DONT_HAVE_ACCOUNT' | translate}} <a class="text-primary link" routerLink="/register">
                {{ 'SIGN_UP_FREE' | translate }}
              </a></p>
            </div>
          </div>

          <form [formGroup]="loginForm" (ngSubmit)="login()" class="row g-3 mb-4">
            <div class="error-message" *ngIf="errorMessage">{{ errorMessage }}</div>
            <!-- Form -->
            <div class="mt-n3 px-2">
              <label class="form-label" for="username">
                {{'EMAIL' | translate}}
              </label>
              <input type="email" class="form-control form-control-lg" id="email" tabindex="1" placeholder="email@address.com"
                aria-label="email@address.com" formControlName="email">
              <div class="error-message text-danger" *ngIf="loginForm.get('email')?.hasError('required') && (loginForm.get('email')?.touched || loginForm.get('email')?.dirty)">
                {{'EMAIL_REQUIRED' | translate}}
              </div>
              <div class="error-message text-danger" *ngIf="loginForm.get('email')?.hasError('email') && (loginForm.get('email')?.touched || loginForm.get('email')?.dirty)">
                {{'EMAIL_INVALID' | translate}}
              </div>
            </div>
            <!-- End Form -->
            <!-- Form -->
            <div class="mb-2 px-2">
              <label class="form-label w-100" for="password" tabindex="0">
                <span class="d-flex justify-content-between align-items-center">
                  <span>
                    {{'PASSWORD' | translate}}
                  </span>
                  <a class="form-label-link mb-0" routerLink="/forgot">
                    {{'FORGOT_PASSWORD' | translate}}
                  </a>
                </span>
              </label>
              <div class="input-group input-group-merge" id="MY" data-hs-validation-validate-class>
                <input type="{{ showPassword ? 'text' : 'password' }}" class="js-toggle-password form-control form-control-lg"
                  name="password" id="password" formControlName="password" placeholder="8+ characters required"
                  aria-label="8+ characters required" minlength="8" style="border-bottom:1px solid #000 ; border-top: 1px solid #000; border-left: 1px solid #000; border-right: none; background-color: transparent;">
                <a id="changePassTarget" type="button" class="input-group-append input-group-text" (click)="togglePasswordVisibility()"
                  style="border-bottom:1px solid #000 ; border-top: 1px solid #000; border-right: 1px solid #000; border-left: none;">
                  <i id="changePassIcon" class="bi-eye"></i>
                </a>
              </div>
              <div class="error-message text-danger" *ngIf="loginForm.get('password')?.hasError('required') && (loginForm.get('password')?.touched || loginForm.get('password')?.dirty)">
               {{'PASSWORD_REQUIRED' | translate}}
              </div>
              <div class="error-message text-danger" *ngIf="loginForm.get('password')?.hasError('minlength') && (loginForm.get('password')?.touched || loginForm.get('password')?.dirty)">
                {{'PASSWORD_VALIDATION' | translate}}
              </div>
            </div>

            <div class="d-grid mb-5" *ngIf="loading">
              <button type="button" class="btn btn-primary btn-lg rounded-4 py-3">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </button>
            </div>
            <div class="d-grid pb-1" *ngIf="!loading">
              <button type="submit" class="btn btn-primary btn-lg rounded-2 mb-3 py-3 shadowfilter" [disabled]="loginForm.invalid" > {{ 'SIGN_IN' | translate }}</button>
            </div>
          </form>

          <div class="position-relative d-flex align-items-center justify-content-center">
            <span class="divider"></span>
            <h6 class="position-absolute text-center divider-text bg-light-subtle mb-0">OR</h6>
         </div>
        <p-divider />

        <div class="action-btns d-grid" *ngIf="platform=='web'">
          <button *ngIf="!googleLaoding"  class="btn google-btn bg-white btn-lg shadow mb-1 d-block d-flex align-items-center text-decoration-none justify-content-center rounded-2" style="border: 1px solid #000;" (click)="LoginWithGoogleForWebPlatForm($event)">
              <img src="../../../assets/images/google.png" alt="google" class="me-1">
              <span>
                {{'CONNECT_WITH_GOOGLE' | translate}}
              </span>
          </button>
          <button *ngIf="googleLaoding"  class="btn google-btn bg-white btn-lg shadow mb-1 d-block d-flex align-items-center text-decoration-none justify-content-center rounded-2" style="border: 1px solid #000;" >
            <img src="../../../assets/images/google.png" alt="google" class="me-3">
            <p-progress-spinner [style]="{ width: '30px', height: '30px' }"></p-progress-spinner>
        </button>
      </div>
      <div class="action-btns d-grid mt-2 pb-9" *ngIf="platform=='web'">
        <button *ngIf="!appleloading" class="btn google-btn  btn-lg btn-dark shadow  d-block d-flex align-items-center text-decoration-none justify-content-center rounded-2" style="border: 1px solid #000;" (click)="LoginWithAppleForWebPlatForm($event)">
          <img src="../../../assets/images/apple.png" alt="google" class="me-3 img-fluid" style="height: 35px;">
          <span>
            {{'CONNECT_WITH_APPLE' | translate}}
          </span>
        </button>
        <button *ngIf="appleloading" class="btn google-btn  btn-lg btn-dark shadow  d-block d-flex align-items-center text-decoration-none justify-content-center rounded-2" style="border: 1px solid #000;" >
          <img src="../../../assets/images/apple.png" alt="google" class="me-3 img-fluid" style="height: 35px;">
          <p-progress-spinner [style]="{ width: '30px', height: '30px' }"></p-progress-spinner>
        </button>
       </div>
        </div>
        <!-- End Form -->
      </div>
      <!-- End Card -->

    
    </div>
    <div class="mx-auto p-2"  *ngIf="platform!='web'">
      <!-- Card -->
      <div class="mb-5">
        <a class="d-flex justify-content-center mb-2 mt-5" routerLink="/">
          <img class="zi-2" src="../../../assets/images/DumyUser/touch.png" alt="Image Description" style="width: 15rem;">
        </a>
       <!-- Form -->
       <div class="js-validate needs-validation" novalidate>
        <div class="text-center pt-5">
          <div class="mb-5">
            <h1 class="display-5">
              {{ 'SIGN_IN' | translate }}
            </h1>
            <p>{{'DONT_HAVE_ACCOUNT' | translate}} <a class="link" routerLink="/register">
              {{ 'SIGN_UP_FREE' | translate }}
            </a></p>
          </div>
        </div>

        <form [formGroup]="loginForm" (ngSubmit)="login()" class="row g-3 mb-4">
          <div class="error-message" *ngIf="errorMessage">{{ errorMessage }}</div>
          <!-- Form -->
          <div class="mt-n3 px-2">
            <label class="form-label" for="username">
              {{'EMAIL' | translate}}
            </label>
            <input type="email" class="form-control form-control-lg" id="email" tabindex="1" placeholder="email@address.com"
              aria-label="email@address.com" formControlName="email">
            <div class="error-message text-danger" *ngIf="loginForm.get('email')?.hasError('required') && (loginForm.get('email')?.touched || loginForm.get('email')?.dirty)">
              {{'EMAIL_REQUIRED' | translate}}
            </div>
            <div class="error-message text-danger" *ngIf="loginForm.get('email')?.hasError('email') && (loginForm.get('email')?.touched || loginForm.get('email')?.dirty)">
              {{'EMAIL_INVALID' | translate}}
            </div>
          </div>
          <!-- End Form -->
          <!-- Form -->
          <div class="mb-2 px-2">
            <label class="form-label w-100" for="password" tabindex="0">
              <span class="d-flex justify-content-between align-items-center">
                <span>
                  {{'PASSWORD' | translate}}
                </span>
                <a class="form-label-link mb-0" routerLink="/forgot">
                  {{'FORGOT_PASSWORD' | translate}}
                </a>
              </span>
            </label>
            <div class="input-group input-group-merge" id="MY" data-hs-validation-validate-class>
              <input type="{{ showPassword ? 'text' : 'password' }}" class="js-toggle-password form-control form-control-lg"
                name="password" id="password" formControlName="password" placeholder="8+ characters required"
                aria-label="8+ characters required" minlength="8" style="border-bottom:1px solid #000 ; border-top: 1px solid #000; border-left: 1px solid #000; border-right: none; background-color: transparent;">
              <a id="changePassTarget" type="button" class="input-group-append input-group-text" (click)="togglePasswordVisibility()"
                style="border-bottom:1px solid #000 ; border-top: 1px solid #000; border-right: 1px solid #000; border-left: none;">
                <i id="changePassIcon" class="bi-eye"></i>
              </a>
            </div>
            <div class="error-message text-danger" *ngIf="loginForm.get('password')?.hasError('required') && (loginForm.get('password')?.touched || loginForm.get('password')?.dirty)">
             {{'PASSWORD_REQUIRED' | translate}}
            </div>
            <div class="error-message text-danger" *ngIf="loginForm.get('password')?.hasError('minlength') && (loginForm.get('password')?.touched || loginForm.get('password')?.dirty)">
              {{'PASSWORD_VALIDATION' | translate}}
            </div>
          </div>

          <div class="d-grid mb-5" *ngIf="loading">
            <button type="button" class="btn btn-primary btn-lg rounded-4 py-3">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
          </div>
          <div class="d-grid pb-1" *ngIf="!loading">
            <button type="submit" class="btn btn-primary btn-lg rounded-2 mb-3 py-3 shadowfilter" [disabled]="loginForm.invalid" >Log in</button>
          </div>
        </form>

        <div class="position-relative d-flex align-items-center justify-content-center">
          <span class="divider"></span>
          <h6 class="position-absolute text-center divider-text bg-light-subtle mb-0">OR</h6>
       </div>
      <p-divider />

      <div class="action-btns d-grid" *ngIf="platform!=='web'">
        <button *ngIf="!googleLaoding"  (click)="LoginWithGoogleFromIOS($event)"  class="btn google-btn bg-white btn-lg shadow mb-1 d-block d-flex align-items-center text-decoration-none justify-content-center rounded-2" style="border: 1px solid #000;" >
            <img src="../../../assets/images/google.png" alt="google" class="me-3">
            <span>{{'CONNECT_WITH_GOOGLE' | translate}}</span>
        </button>
        <button *ngIf="googleLaoding"  class="btn google-btn bg-white btn-lg shadow mb-1 d-block d-flex align-items-center text-decoration-none justify-content-center rounded-2" style="border: 1px solid #000;" >
          <img src="../../../assets/images/google.png" alt="google" class="me-3">
          <p-progress-spinner [style]="{ width: '30px', height: '30px' }"></p-progress-spinner>
      </button>
    </div>
    <div class="action-btns d-grid mt-2 pb-9" *ngIf="platform!=='web'">
      <button *ngIf="!appleloading" class="btn google-btn  btn-lg btn-dark shadow  d-block d-flex align-items-center text-decoration-none justify-content-center rounded-2" style="border: 1px solid #000;" (click)="LoginWithAppleFromIOS($event)">
        <img src="../../../assets/images/apple.png" alt="google" class="me-3 img-fluid" style="height: 35px;">
        <span> {{'CONNECT_WITH_APPLE' | translate}}</span>
      </button>
      <button *ngIf="appleloading" class="btn google-btn  btn-lg btn-dark shadow  d-block d-flex align-items-center text-decoration-none justify-content-center rounded-2" style="border: 1px solid #000;" >
        <img src="../../../assets/images/apple.png" alt="google" class="me-3 img-fluid" style="height: 35px;">
        <p-progress-spinner [style]="{ width: '30px', height: '30px' }"></p-progress-spinner>
      </button>
     </div>
      </div>
      <!-- End Form -->
      </div>
      <!-- End Card -->

    
    </div>
  </div>
  <!-- End Content -->
</main>
<!-- ========== END MAIN CONTENT ========== -->





